import _ from 'lodash'
import useIdToFindCategoryParent from '@/views/creative/utils/use-id-to-find-category-parent.js'
import { isDragonBones, isFrameSequence, isModelResource } from './index.ts'
import {
  gameConfigCategoryResourceType,
  i18nCategoryResourceType,
} from '@/store/creative/common/category'
import { isPresetPrefix } from '@/views/creative/utils/preset-utils'

/**
 * 生成多组合groupList数组
 * @param {Object} resource state.creative.template.templateConfig.resource
 * @param {Object} i18nResource state.creative.template.i18nResource
 * @param {Object} gameConfigResource state.creative.template.gameConfigResource
 * @param {object} templateConfig state.creative.template.templateConfig
 * @param {Object} 制作页面一整个 state
 */
export default function generateGroupList({
  resource,
  i18nResource,
  gameConfigResource,
  templateConfig,
  state,
}) {
  resource = {}
  i18nResource = {}
  // 普通制作的时候改为空对象
  gameConfigResource = {}

  // 加工 resource，主要是为了加工 name 属性便于生成 groupsConfig
  // 后端生成 excel 与前端展示时需要使用
  // todo: 有优化空间，将 resource/i18nResource/gameConfigResource 整合在一块处理，方便维护
  const cookResourceList = (resource) => {
    _.each(resource, (resourceItem, key) => {
      resource[key] = resourceItem
        .map((item, index) => {
          return {
            ...item,
            name: `${item.prefix}-${index + 1}`,
          }
        })
        .filter((item) => item.deleted !== 1)
    })
    return resource
  }
  resource = cookResourceList(_.cloneDeep(resource))

  const groupArray = [] // 存储多组合各子项数量
  const multiNormalRes = {} // 存储普通资源多组合对象
  const multiI18nRes = {} // 存储i18n多组合对象
  const multiGameConfigRes = {} // 存储gameConfig多组合对象
  let groupList = [] // 存储多组合列表
  const getMinRes = (resource) => {
    return {
      category_id: resource.category_id,
      id: resource.id,
      resource_type: resource.resource_type,
      name: resource.name,
      prefix: resource.prefix,
      sub_resource_type: resource.sub_resource_type,
    }
  }
  // 合并二维数组
  const mixDyadicArray = (array) => {
    if (array && array.length) {
      if (array.length === 1) {
        return array[0].map((item) => [item])
      }
      return array.reduce((pre, cur) => {
        return [].concat(...pre.map((e) => cur.map((ele) => [].concat(ele, e))))
      })
    }
    return []
  }

  const objectToArray = (object) => {
    return _.map(object, (item) => {
      return item
    })
  }

  // 判断是否是元素面板
  const isElementPanel = (resource) => {
    const categoryParent = useIdToFindCategoryParent({
      category: templateConfig.category,
      categoryId: Number(resource.category_id),
    })
      .reverse()
      .shift()
    return Number(categoryParent.id) === 1
  }

  // 判断是否是玩法面板
  const isPlayPanel = (resource) => {
    const categoryParent = useIdToFindCategoryParent({
      category: templateConfig.category,
      categoryId: Number(resource.category_id),
    })
      .reverse()
      .shift()
    return Number(categoryParent.id) === 3
  }

  _.forEach(resource, (value, key) => {
    if (!isElementPanel(value[0]) && !isPlayPanel(value[0])) return
    // 多组合忽略已删除的资源和预设资源
    const activeValue = value.filter((item) => {
      return item.action !== 'del' && !isPresetPrefix(String(item.prefix))
    })
    if (activeValue && activeValue.length > 1) {
      // 关联资源只需要算一份数据
      let keyTemp = key
      if (activeValue[0].category_ids) {
        keyTemp = activeValue[0].category_ids
      }
      if (!multiNormalRes[keyTemp]) {
        groupArray.push(activeValue.length)
        multiNormalRes[keyTemp] = activeValue.map((item) => getMinRes(item))
      }
    }
  })

  _.forEach(i18nResource, (value, key) => {
    if (!isElementPanel(value[0]) && !isPlayPanel(value[0])) return
    if (value && value.length > 1) {
      groupArray.push(value.length)
      multiI18nRes[key] = value.map((item) => getMinRes(item))
    }
  })

  _.forEach(gameConfigResource, (value, key) => {
    if (
      !isElementPanel(value[0]) &&
      !isPlayPanel(value[0]) &&
      key !== 'gameDifficultyList'
    ) {
      return
    }
    if (value && value.length > 1) {
      groupArray.push(value.length)
      multiGameConfigRes[key] = value.map((item) => getMinRes(item))
    }
  })

  groupList = mixDyadicArray(
    _.concat(
      objectToArray(multiNormalRes),
      objectToArray(multiI18nRes),
      objectToArray(multiGameConfigRes),
    ),
  )

  if (groupList.length) {
    groupList = _.map(groupList, (item, index) => {
      return {
        name: 'group-' + (index + 1),
        resource: {
          // 只有通过验证的普通资源才会进入多组合元素里面
          list: item.filter((item) => {
            return (
              item.resource_type === 'normal' ||
              isDragonBones(item.prefix) ||
              isFrameSequence(item.prefix, item.resource_type) ||
              isModelResource(item)
            )
          }),
        },
        i18n: {
          list: item.filter(
            (item) => item.resource_type === i18nCategoryResourceType,
          ),
          data: '',
        },
        game_config: {
          data: '',
          list: item.filter(
            (item) => item.resource_type === gameConfigCategoryResourceType,
          ),
        },
      }
    })
  } else {
    groupList = [
      {
        name: 'group-1',
        resource: {
          list: [],
        },
        i18n: {
          list: [],
          data: '',
        },
        game_config: {
          data: '',
          list: [],
        },
      },
    ]
  }

  return groupList
}
